import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'delete-btn',
	template: require('./delete-btn.html'),
	styles: [require('./delete-btn.scss')]
})
export class DeleteBtnComponent implements OnInit {
	@Input() text: string;
	@Input() isEmpty: boolean;
	@Input() isDisabled: boolean;
	@Input() addClass: any;
	@Output() clicked: EventEmitter<void> = new EventEmitter();
	btnText: string;

	constructor() {}

	ngOnInit() {
		this.btnText = this.text || 'Delete';
		if (this.isEmpty) {
			this.btnText = '';
		}
	}

	public handleClick(event: any) {
		this.clicked.emit(event);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/buttons/delete-btn/delete-btn.ts